import React, { useContext } from 'react';
import { useLocale } from 'locale';
import ShareIcon from 'assets/svg/interface-16-share.svg';
import { ControlButton } from 'ds/components/button';
import { ShareButton } from 'components/navigation/share/ShareButton';
import { isServer } from 'utils';
import { shareHandler, ShareType } from 'helpers/share-helpers';
import { routeContext } from 'react-router5';
import { Route } from 'config/routes';
import { IDeveloperProfile } from 'utils/entities';
import { ShareWrapper } from './styled';

interface ShareProps {
  developer: IDeveloperProfile;
  iconOnly?: boolean;
}

export const Share: React.FC<ShareProps> = ({ developer, iconOnly }) => {
  const { t } = useLocale();
  const router = useContext(routeContext);
  const shouldResetSelectedValue = () => true;
  const shouldStayOpen = (value: ShareType) => value === ShareType.CopyLink;
  const copyText = isServer() ? null : (
    window.location.origin + router.router.buildUrl(Route.DeveloperPage, { id: developer.id })
  );
  const handleShare = (type: ShareType) => {
    shareHandler({ type, url: window.location.href, shareViaEmailOptions: {
      body: copyText,
      subject: developer.name,
      t,
    } });
  };

  return (
    <ShareWrapper>
      <ShareButton
        copyText={copyText}
        shouldResetSelectedValue={shouldResetSelectedValue}
        shouldStayOpen={shouldStayOpen}
        handleShare={handleShare}
      >
        {iconOnly ? null : (
          <ControlButton data-auto="developer-share">
            <ShareIcon width={16} height={16} />
            {t('tooltip.share')}
          </ControlButton>
        )}
      </ShareButton>
    </ShareWrapper>
  );
};
